import React, { useMemo } from 'react';

import type { DeclarativeMenuConfig } from 'src/components/declarative-menu';
import { WordCountIcon } from 'src/components/icons/WordCountIcon';

import { plannedOnly } from '../shared/menu-mixins';

export function useToolsMenu() {
  return useMemo(
    (): DeclarativeMenuConfig => [{ icon: <WordCountIcon />, label: 'Word count', ...plannedOnly }],
    []
  );
}
